import {Icon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M12 6H4v7a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V6zM2 4V3a3 3 0 0 1 3-3h6a3 3 0 0 1 3 3v1h2v2h-2v7a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3V6H0V4h2zm2 0h8V3a1 1 0 0 0-1-1H5a1 1 0 0 0-1 1v1zm2 3h1v6H6V7zm3 0h1v6H9V7z",
      fill: "currentColor",
      "fill-rule": "nonzero"
    }, null, -1)
  ]))]))
}
export default { render() { return h(Icon, {icon: {render}, name: "icon-trash"}) } }